import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { WSHomePageDTO } from '@interfaces/dws/ws-homepage';

@Injectable({
  providedIn: 'root'
})
export class WSHomePageService {

  constructor() {
  }

  getHomepageData(wineryId: string): Observable<WSHomePageDTO> {
    return resource(`crm://winery/wineryId/homepage-data`)
    .params({ wineryId })
      .get<WSHomePageDTO>();
  }
}
